import { ErrorHandler, Injectable, inject, isDevMode } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly notification = inject(NotificationService);

  handleError(error: unknown): void {
    const friendlyMessage = this.resolveFriendlyMessage(error);

    this.notification.error(friendlyMessage);

    if (isDevMode()) {
      console.error('[GlobalErrorHandler]', error);
    } else {
      const message = error instanceof Error ? error.message : String(error);
      console.error('[GlobalErrorHandler]', message);
    }
  }

  private resolveFriendlyMessage(error: unknown): string {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 401 || error.status === 403) {
        return 'No tienes Permissions para realizar esta accion.';
      }
      if (error.status === 404) {
        return 'El recurso solicitado no fue encontrado.';
      }
      if (error.status >= 500) {
        return 'Error en el servidor. Por favor intenta mas tarde.';
      }
      return 'Error de red. Verifica tu conexion.';
    }

    return 'An unexpected error occurred. Please reload the page.';
  }
}

